import React from "react";
import {
  Modal,
  Typography,
  Box as MuiBox,
  Divider,
  Accordion,
  AccordionDetails,
  AccordionSummary
} from "@mui/material";
import ReactMarkdown from "react-markdown";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledAccordion = styled(Accordion)(() => ({
  borderRadius: "25px",

  // This overrides the default MUI rule
  "&:first-of-type": {
    borderTopLeftRadius: "25px",
    borderTopRightRadius: "25px",
  },
  "&:last-of-type": {
    borderBottomLeftRadius: "25px",
    borderBottomRightRadius: "25px",
  },
}));

function FaqModal ({ articles, open, onClose }) {
  return(
    <Modal open={open} onClose={onClose}>
      <MuiBox
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "85%",
          height: "80%",
          bgcolor: "background.paper",
          borderRadius: "25px",
          boxShadow: 24,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MuiBox
          sx={{
            position: "sticky",
            top: 0,
            bgcolor: "background.paper",
            zIndex: 1,
            px: 4,
            pt: 4,
            pb: 1,
            borderTopLeftRadius: "25px",
            borderTopRightRadius: "25px"
          }}
        >
          <Typography 
            id="file-management-modal-title" 
            variant="h3" 
            component="h3"
            sx={{ color: "#392545", fontWeight: "550", mb: "1vh" }}
          >
            FAQ
          </Typography>
          <Divider />
        </MuiBox>

        <MuiBox
          sx={{
            px: 4,
            pb: 4,
            overflow: "auto",
            flexGrow: 1
          }}
        >
          {articles.length === 0 ? (
            <Typography align="center">No articles found.</Typography>
          ) : (
            articles.map((article, index) => (
              <MuiBox key={article.Id || article.Title || index} sx={{ mb: "2vh", mt: "1vh" }}>
                <StyledAccordion slotProps={{ heading: { component: 'h4' } }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    variant="h4"
                    aria-controls={`panel-${index}-content`}
                    id={`panel-${index}-header`}
                  >
                    <Typography variant="h6" sx={{ fontWeight: "600" }}>
                      {article.Title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Divider sx={{ mb: "2vh" }} />
                    <Typography variant="body2">
                      <ReactMarkdown
                        components={{
                          p: ({ children }) => <Typography variant="body1" paragraph>{children}</Typography>,
                          ul: ({ children }) => <ul style={{ paddingLeft: 16 }}>{children}</ul>,
                          li: ({ children }) => <li>{children}</li>,
                        }}
                      >
                        {article.Content}
                      </ReactMarkdown>
                    </Typography>
                  </AccordionDetails>
                </StyledAccordion>
              </MuiBox>
            ))
          )}
        </MuiBox>
      </MuiBox>
    </Modal>
  )
}

export default FaqModal;